import {Injectable} from "@angular/core"
import {CurrentUserStore} from "app/common/services/current-user/CurrentUserStore"
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    CanLoad,
    Data,
    Route,
    RouterStateSnapshot
} from "@angular/router"
import {NgObservableLike} from "types/AngularExtensions"
import {Optional} from "app/common/util/Optional"
import {Observable, of} from "rxjs"
import {first, map} from "rxjs/operators"

@Injectable({providedIn: "root"})
export class AuthenticationGuard implements CanLoad, CanActivate, CanActivateChild {

    public constructor(private store: CurrentUserStore) {

    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): NgObservableLike<boolean> {
        return this.isUserAccessible(route.data)
    }

    public canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): NgObservableLike<boolean> {
        return this.canActivate(childRoute, state)
    }

    public canLoad(route: Route): NgObservableLike<boolean> {
        return this.isUserAccessible(route.data)
    }

    private isUserAccessible(data?: Data): Observable<boolean> {
        const isPublic = Optional.of(data)
                                 .map((d) => d["public"])
                                 .orElse(false)
        if (isPublic) {
            return of(true)
        } else {
            return this.store
                       .currentUser
                       .pipe(first())
                       .pipe(map((user) => user != null))
        }
    }
}
